// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"0d94ce5a","70":"0ae12666","288":"5f189802"}[chunkId] + ".chunk.js";
};